<div class="loader-overlay">
    <div class="loader-overlay__loader"></div>
</div>
